console.log('starting gems online participant app...');
require ('./app/common');
require ('./app/online-global');
require ('./app/online-participant');
